import _ from "lodash";

export const session = {
    clear: clear,
    getItem: getItem,
    setItem: setItem,
    remove: removeItem,
    setObject: setObject,
    getObject: getObject,
}

function clear() {
    sessionStorage.clear();
}

function setItem(key: any, value: any) {
    sessionStorage.setItem(key, value);
}

function getItem(key: any) {
    if (typeof window !== 'undefined') {
        return sessionStorage.getItem(key);
    }
}

function removeItem(key: any) {
    return sessionStorage.removeItem(key);
}

function setObject(key: any, value: any) {
    let strJSON = JSON.stringify(value);
    sessionStorage.setItem(key, strJSON);
}

function getObject(key: any) {
    let strJSON: any = sessionStorage.getItem(key);
    let resultObj = JSON.parse(strJSON);
    return resultObj;
}


